import { gql } from '@apollo/client'

const updateVenueDevice = gql(`
  mutation updateVenueDevice($email: String, $deviceId: String!, $description: String, $platformType: String, $active: Boolean, $osVersion: String, $appVersion: String ){
    updateVenueDevice(
      email : $email
      deviceId : $deviceId
      description : $description
      platformType : $platformType
      active : $active
      osVersion : $osVersion
      appVersion: $appVersion
    ){
    error {
      message
    }
    success 
    data{
      message
    }
    }
  }`)

export default updateVenueDevice
